export const DEFAULT_LANG = "ar";
export const MSG_DURATION = 5;
export const IMG_BASE_URL = 'https://haraj-image-hosting.s3.me-south-1.amazonaws.com/';
